"use client";

import { useLayoutEffect, type ReactNode } from "react";
import { I18nextProvider } from "react-i18next";
import i18n, {
  LANG_STORAGE_KEY,
  LANG_COOKIE_NAME,
  normalizeLocale,
} from "@/lib/i18n";

function setLangCookie(lang: string) {
  if (typeof document !== "undefined") {
    document.cookie = `${LANG_COOKIE_NAME}=${lang}; path=/; max-age=31536000; SameSite=Lax`;
  }
}

export default function I18nProvider({
  children,
  initialLanguage = "es-AR",
}: {
  children: ReactNode;
  initialLanguage?: string;
}) {
  const normalized = normalizeLocale(initialLanguage);
  // Client bundle re-inits i18n to es-AR — align before any child runs t() so hydration matches SSR.
  if (normalizeLocale(i18n.language) !== normalized) {
    void i18n.changeLanguage(normalized);
  }

  useLayoutEffect(() => {
    if (normalizeLocale(i18n.language) !== normalized) {
      void i18n.changeLanguage(normalized);
    }
    localStorage.setItem(LANG_STORAGE_KEY, normalized);
    setLangCookie(normalized);
  }, [normalized]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
